var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wasgeht.length > 0)?_c('b-container',{staticClass:"my-7",attrs:{"id":"whatsup"}},[_c('b-row',[_c('b-col',[_c('h2',[_vm._v("Was geht?")])])],1),_c('JukiAccordion',{attrs:{"contentlist":_vm.contentList}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }